import React from "react";

function Footer() {
  return (
    <footer className="box-border w-full max-w-[100vw] overflow-x-clip bg-gradient-to-b from-[#313131] to-[#272727] px-4 py-4 text-white sm:px-5 sm:py-5">
      <div className="mx-auto flex w-full max-w-6xl flex-wrap items-center justify-center gap-x-5 gap-y-2 text-center">
        <div className="flex w-full flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:w-auto">
          <a
            href="/privacy"
            className="whitespace-nowrap text-white no-underline transition-colors duration-200 hover:underline"
          >
            Privacy Policy
          </a>
          <a
            href="/terms"
            className="whitespace-nowrap text-white no-underline transition-colors duration-200 hover:underline"
          >
            Terms of Service
          </a>
        </div>
        <p className="w-full px-2 leading-relaxed break-words text-sm sm:text-[0.95rem]">
          &copy; 2024 Rising Stars Public School. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
